import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy, DatePipe } from '@angular/common';
import { AuthConfig, provideOAuthClient } from 'angular-oauth2-oidc';

import { routes } from './app.routes';
import { AuthService } from '@guard/auth.service';
import { authCodeFlowConfig } from '@guard/auth-config';
import { authInterceptor } from './interceptor';

export function init_app(authConfigService: AuthService) {
  return () => authConfigService.initAuth();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideOAuthClient(),
    provideAppInitializer(() => inject(AuthService).initAuth()),
    DatePipe,
    { provide: AuthConfig, useValue: authCodeFlowConfig },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
};
